import React, { useState } from "react";
import classNames from "classnames";
import { TreeNode } from "./TreeNode";
import TreeItem from "./TreeItem";
import { TreeProps } from "./PropsType";

export default function Tree(props: TreeProps) {
  const {
    className,
    children,
    emptyMessage,
    loading,
    passSelectedUp = true,
    passSelectedDown = true,
    prefixCls = "bm-Tree",
  } = props;
  const styleClass = classNames(prefixCls, className);
  const [data, setData] = useState({
    selection: [],
    value: (props.value as any).length > 0 ? props.value : [],
  });
  //   let nodeTouched = false;
  const { value } = data;
  let selection: any[] = Array.isArray(data.selection)
    ? [...data.selection]
    : data.selection;

  const onNodeClick = (event: any, node: TreeNode) => {
    const {
      selectionChange,
      onNodeUnselect,
      onNodeSelect,
      passSelectedDown,
      passSelectedUp,
      selectionMode,
      selection,
    }: any = props;
    if (selectionMode) {
      const index = findIndexInSelection(node);
      const selected = index >= 0;

      if (isCheckboxSelectionMode()) {
        if (selected) {
          if (passSelectedDown) {
            passDown(node, false);
          } else {
            this.selection = getSelection(index);
          }

          if (passSelectedUp && node.parent) {
            passUp(node.parent, false);
          }
          if (typeof selectionChange === "function") {
            selectionChange(this.selection);
          }
          if (typeof onNodeUnselect === "function") {
            onNodeUnselect({ originalEvent: event, node: node });
          }
        } else {
          if (passSelectedDown) {
            passDown(node, true);
          } else {
            this.selection = [...(selection || []), node];
          }

          if (passSelectedUp && node.parent) {
            passUp(node.parent, true);
          }
          if (typeof selectionChange === "function") {
            selectionChange(this.selection);
          }
          if (typeof onNodeSelect === "function") {
            onNodeSelect({ originalEvent: event, node: node });
          }
        }
      } else {
        if (isSingleSelectionMode()) {
          if (selected) {
            this.selection = null;
            if (typeof onNodeUnselect === "function") {
              onNodeUnselect({ originalEvent: event, node: node });
            }
          } else {
            this.selection = node;
            if (typeof onNodeSelect === "function") {
              onNodeSelect({ originalEvent: event, node: node });
            }
          }
        } else {
          if (selected) {
            this.selection = getSelection(index);
            if (typeof onNodeUnselect === "function") {
              onNodeUnselect({ originalEvent: event, node: node });
            }
          } else {
            this.selection = [...(this.selection || []), node];
            if (typeof onNodeSelect === "function") {
              onNodeSelect({ originalEvent: event, node: node });
            }
          }
        }
        if (typeof selectionChange === "function") {
          selectionChange(this.selection);
        }
      }
    }

    this.setState({
      selection: this.selection,
    });
    this.nodeTouched = false;
  };

  //   const onNodeTouchEnd = () => {
  //     nodeTouched = true;
  //   };

  const passUp = (node: TreeNode, select: boolean) => {
    if (node.children && node.children.length) {
      let selectedCount = 0;
      let childPartialSelected = false;
      for (const child of node.children) {
        if (isSelected(child)) {
          selectedCount++;
        } else if (child.partialSelected) {
          childPartialSelected = true;
        }
      }

      if (select && selectedCount === node.children.length) {
        selection = [...(selection || []), node];
        node.partialSelected = false;
      } else {
        if (!select) {
          const index = findIndexInSelection(node);
          if (index >= 0) {
            selection = getSelection(index);
          }
        }

        node.partialSelected =
          childPartialSelected ||
          (selectedCount > 0 && selectedCount !== node.children.length);
      }
    }

    const parent = node.parent;
    if (parent) {
      passUp(parent, select);
    }
  };

  const passDown = (node: TreeNode, select: boolean) => {
    const index = findIndexInSelection(node);

    if (select && index === -1) {
      selection = [...(selection! || []), node];
    } else if (!select && index > -1) {
      selection = getSelection(index);
    }

    node.partialSelected = false;

    if (node.children && node.children.length) {
      for (const child of node.children) {
        passDown(child, select);
      }
    }
  };

  const getSelection = (index: number) => {
    return selection.filter((val: any, i: number) => val && i !== index);
  };

  const findIndexInSelection = (node: TreeNode) => {
    let index = -1;

    if (props.selectionMode && selection) {
      if (isSingleSelectionMode()) {
        index = selection === node ? 0 : -1;
      } else {
        for (let i = 0; i < selection.length; i++) {
          if (selection[i] === node) {
            index = i;
            break;
          }
        }
      }
    }

    return index;
  };

  const isSelected = (node: TreeNode) => {
    return findIndexInSelection(node) !== -1;
  };

  const isSingleSelectionMode = () => {
    return props.selectionMode && props.selectionMode === "single";
  };

  const isCheckboxSelectionMode = () => {
    return props.selectionMode && props.selectionMode === "checkbox";
  };

  const getTemplateForNode = (node: TreeNode) => {
    const template: any = props.template;
    if (typeof template === "function") {
      return template(node);
    }
    return null;
  };
  return (
    <div className={styleClass}>
      <div className={styleClass}>
        {loading ? (
          <div className={`${prefixCls}-loading`}>
            <div className={`${prefixCls}-loading-mask`} />
            <div className={`${prefixCls}-loading-content`} />
          </div>
        ) : null}
        <ul className={`${prefixCls}-inner`}>
          {value.map((node: any, index: number) => {
            return (
              <TreeItem
                selection={selection}
                tree={this}
                node={node}
                key={`TreeNode-${index}`}
                index={index}
              />
            );
          })}
        </ul>
        {!loading && value.length > 0 ? (
          <div className={`${prefixCls}-empty-message`}>{emptyMessage}</div>
        ) : null}
      </div>
    </div>
  );
}
